<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@clubOverviewComponent.sectionHeading.GdprSettings' class="esf-action-heading__text">GDPR Settings</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              (click)="editGdprSettings();$event.stopPropagation();"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">

    <div class="esf-icon-and-text esf-icon-and-text--xs hero-image">
      <svg class="esf-icon" width="16" height="16">
        <use xlink:href="#esf-icon-circle-check"></use>
      </svg>
      <div class="esf-icon-and-text__text" i18n='@@tixxFanPortal.text.setupCompleted'>Setup completed.</div>
    </div>

  </div>
</div>
